/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const efdbJson = async (): Promise<any> => {
  const {efdbJSON, setEfdbJSON} = useJSONStore.getState();
  const token = useUserStore.getState().userToken;

  if (efdbJSON.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.efdb}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setEfdbJSON(res.data.data);
      })
      .catch((err) => {
        setEfdbJSON([]);

        return err.message;
      });
  }
};

export default efdbJson;
